export const ALLOWED_PAYMENT_TYPES = [
    'PIX',
    // 'CREDIT_CARD', // suspenso novamente - 2026-09-14 — reativar: descomentar esta linha
] as const
